var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view == 'cupones')?_c('view-component',{attrs:{"show_filter_modal":"","model_name":"cupon"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }